import React, { ReactNode, useContext, useEffect, useMemo, useState } from 'react';
import { IPostViewModel } from 'viewModels';
import { useAuth } from './auth';
import { PostController } from '../controller/PostController';

type PostContextProps = {
  children: ReactNode;
};

interface IInitialValues {
  posts: IPostViewModel[];
  setPosts: React.Dispatch<React.SetStateAction<IPostViewModel[]>>;
  activePostsId: string | undefined;
  setActivePostsId: React.Dispatch<React.SetStateAction<string | undefined>>;
}

const PostContext = React.createContext({} as IInitialValues);

const PostContextProvider = ({ children }: PostContextProps) => {
  const { user, tokenIsValid } = useAuth();
  const [posts, setPosts] = useState<IPostViewModel[]>([]);
  const [activePostsId, setActivePostsId] = useState<string | undefined>();

  useEffect(() => {
    if (!tokenIsValid) {
      setPosts([]);
      setActivePostsId(undefined);
    }
  }, [tokenIsValid]);

  useEffect(() => {
    if (user?.id && tokenIsValid) {
      PostController.getPosts().then((response) => {
        setPosts(
          response.sort(
            (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
          ),
        );
      });
    }
  }, [tokenIsValid, user?.id]);

  const contextValues = useMemo(
    () => ({ posts, setPosts, activePostsId, setActivePostsId }),
    [posts, activePostsId],
  );
  return <PostContext.Provider value={contextValues}>{children}</PostContext.Provider>;
};
export const usePosts = () => useContext(PostContext);
export default PostContextProvider;
